export const TRACKING_HOOKS = Object.freeze([
  {
    selector:
      '.shopify-section--lp-header .lp-header__external-desktop-host .lp-nav-content-item--link[href="/pages/maschinenvergleich"], .shopify-section--lp-header .lp-header__external-mobile-host .lp-nav-content-item--link[href="/pages/maschinenvergleich"]',
    event: 'click_navigation_compare',
    context: 'header_navigation_compare',
    source: 'vendor',
    storeKeys: ['laserpecker-de'],
  },
  {
    selector: '.shopify-section--header a[aria-controls="search-drawer"]',
    event: 'click_top_search',
    context: 'header',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--header button[type="submit"][name="country_code"], .footer button[type="submit"][name="country_code"]',
    event: 'select_country_language',
    context: 'country_selector',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--header button[type="submit"][name="locale_code"], .footer button[type="submit"][name="locale_code"]',
    event: 'select_country_language',
    context: 'language_selector',
    source: 'vendor',
  },
  {
    selector: '.shopify-section--header shopify-account',
    event: 'click_top_account',
    context: 'header_account',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--header a[aria-controls="cart-drawer"], .shopify-section--header a[href="/cart"]',
    event: 'click_top_cart',
    context: 'header_cart',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--header .header__main-nav .header__link-list > ul.contents > li > a, .shopify-section--header .header__main-nav .header__link-list > ul.contents > li > details > summary, .shopify-section--header .header__main-nav .header__link-list > ul.contents > li > button',
    event: 'click_top_category',
    context: 'header_desktop_nav',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--header .mega-menu__nav > li > a, .shopify-section--header .header__main-nav .header__link-list > ul.contents > li > details > .dropdown-menu > ul.contents > li > a, .shopify-section--header .header__main-nav .header__link-list > ul.contents > li > details > .dropdown-menu > ul.contents > li > details > summary',
    event: 'click_second_category',
    context: 'header_desktop_nav',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--header .mega-menu__nav > li > ul a, .shopify-section--header .header__main-nav .header__link-list > ul.contents > li > details > .dropdown-menu > ul.contents > li > details > .dropdown-menu a',
    event: 'click_third_category',
    context: 'header_desktop_nav',
    source: 'vendor',
  },
  {
    selector:
      '#header-sidebar-menu .panel-list__wrapper > .panel:first-child > .panel__wrapper > .panel__scroller > ul:first-of-type > li > :is(a, button)',
    event: 'click_top_category',
    context: 'header_mobile_nav',
    source: 'vendor',
  },
  {
    selector:
      '#header-sidebar-menu .panel-list__wrapper > .panel:nth-child(2) > .panel__wrapper > ul > li > :is(a, button)',
    event: 'click_second_category',
    context: 'header_mobile_nav',
    source: 'vendor',
  },
  {
    selector: '#header-sidebar-menu .panel-list__wrapper > .panel:nth-child(3) > .panel__wrapper a',
    event: 'click_third_category',
    context: 'header_mobile_nav',
    source: 'vendor',
  },
  {
    selector: '.shopify-section--lp-header [data-lp-account-entry]',
    event: 'click_top_account',
    context: 'header_account',
    source: 'vendor',
  },
  {
    selector: '.shopify-section--lp-market-topbar .lp-market-topbar__card',
    event: 'select_country_language',
    context: 'country_selector',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--lp-header .lp-header__nav-list > .lp-header__nav-item > :is(.lp-header__nav-button, .lp-header__nav-link)',
    event: 'click_top_category',
    context: 'header_desktop_nav',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--lp-header .lp-header__mega--products .lp-header__category-button, .shopify-section--lp-header .lp-header__mega--pages .lp-nav-page-card',
    event: 'click_second_category',
    context: 'header_desktop_nav',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--lp-header .lp-header__mega--products :is(.lp-header__product-panel-link, .lp-nav-product-card, .lp-nav-page-card)',
    event: 'click_third_category',
    context: 'header_desktop_nav',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--lp-header .lp-header__external-desktop-host .lp-nav-content-item--link',
    event: 'click_third_category',
    context: 'header_desktop_nav',
    source: 'vendor',
    refreshContext: true,
  },
  {
    selector:
      '.shopify-section--lp-header .lp-header__drawer-nav > .lp-header__drawer-section > .lp-header__drawer-summary, .shopify-section--lp-header .lp-header__drawer-nav > .lp-header__drawer-link',
    event: 'click_top_category',
    context: 'header_mobile_nav',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--lp-header .lp-header__drawer-product-category > .lp-header__drawer-product-category-summary, .shopify-section--lp-header .lp-header__drawer-content--pages .lp-nav-page-card',
    event: 'click_second_category',
    context: 'header_mobile_nav',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--lp-header .lp-header__drawer-product-category-content :is(.lp-header__drawer-collection-cta, .lp-nav-product-card, .lp-header__drawer-helpful-link)',
    event: 'click_third_category',
    context: 'header_mobile_nav',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--lp-header .lp-header__external-mobile-host .lp-nav-content-item--link',
    event: 'click_third_category',
    context: 'header_mobile_nav',
    source: 'vendor',
    refreshContext: true,
  },
  {
    selector: '.shopify-section--slideshow',
    event: 'view_homepage_banner',
    context: 'homepage_banner',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--slideshow a[href], .shopify-section--slideshow .slideshow__slide button.button',
    event: 'click_homepage_banner',
    context: 'homepage_banner',
    source: 'vendor',
  },
  {
    selector: '.v2-fourNav .homepage-v2-four-nav__link',
    event: 'click_item_types',
    context: 'homepage_category',
    source: 'vendor',
    storeKeys: ['laserpecker-global'],
  },
  {
    selector: '.v2-tabVideo [data-homepage-v2-tab-index]',
    event: 'click_item_types',
    context: 'homepage_video_tab',
    source: 'vendor',
    storeKeys: ['laserpecker-global'],
  },
  {
    selector:
      '.v2-machine-list .homepage-v2-machine-card__button, .shopify-section--multi-column a.homepage-testimonials__button--secondary, .shopify-section--multi-column .multi-column__item a.link, .shopify-section--image-with-text-overlay .prose a.button',
    event: 'learn_more',
    context: 'homepage_content',
    source: 'vendor',
  },
  {
    selector: '.shopify-section--main-collection product-card a[href*="/products/"]',
    event: 'select_item',
    context: 'collection_grid',
    source: 'vendor',
    storeKeys: ['laserpecker-global'],
  },
  {
    selector: '.shopify-section--main-search product-card a[href*="/products/"]',
    event: 'select_item',
    context: 'search_results',
    source: 'vendor',
    storeKeys: ['laserpecker-global'],
  },
  {
    selector: 'search-drawer .predictive-search-result[href*="/products/"]',
    event: 'select_item',
    context: 'predictive_search',
    source: 'vendor',
    storeKeys: ['laserpecker-global'],
  },
  {
    selector:
      '.shopify-section--main-cart ~ .shopify-section--featured-collection product-card a[href*="/products/"]',
    event: 'select_item',
    context: 'cart_recommendations',
    source: 'vendor',
    storeKeys: ['laserpecker-global'],
  },
  {
    selector: '.shopify-section--featured-collection product-card a[href*="/products/"]',
    event: 'select_item',
    context: 'featured_collection',
    source: 'vendor',
    storeKeys: ['laserpecker-global'],
  },
  {
    selector:
      '.shopify-section--product-recommendations product-card a[href*="/products/"], .lp5-compatible-products product-card a[href*="/products/"]',
    event: 'select_item',
    context: 'pdp_recommendations',
    source: 'vendor',
    storeKeys: ['laserpecker-global'],
  },
  {
    selector:
      '.shopify-section--main-cart ~ .shopify-section--featured-collection .product-card .product-card__quick-buy > form[is="product-form"] button[type="submit"], .shopify-section--main-cart ~ .shopify-section--featured-collection .product-card button[aria-controls^="quick-buy-"]',
    event: 'custom_add_to_cart',
    context: 'cart_you_may_also_like',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--featured-collection .product-card .product-card__quick-buy > form[is="product-form"] button[type="submit"], .shopify-section--featured-collection .product-card button[aria-controls^="quick-buy-"]',
    event: 'custom_add_to_cart',
    context: 'home_quick_add',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section--main-collection .product-card .product-card__quick-buy > form[is="product-form"] button[type="submit"], .shopify-section--main-collection .product-card button[aria-controls^="quick-buy-"]',
    event: 'custom_add_to_cart',
    context: 'collection_quick_add',
    source: 'vendor',
  },
  {
    selector: '.shopify-section--main-product .product-info__buy-buttons',
    event: 'custom_add_to_cart',
    context: 'pdp_form',
    source: 'vendor',
    sectionType: 'main-product',
  },
  {
    selector:
      '.shopify-section--main-product buy-buttons[form][class~="sm:hidden"], .shopify-section--main-product buy-buttons[form][force-secondary-button]',
    event: 'custom_add_to_cart',
    context: 'pdp_sticky_bar',
    source: 'vendor',
    sectionType: 'main-product',
  },
  {
    selector:
      '[data-craft-fair-section="v2-nav2"] .v2-nav-li, .v2-navFrame[class*="__v2_nav2_"] .v2-nav-li',
    event: 'click_item_detail_nav',
    context: 'pdp_detail_nav',
    source: 'vendor',
    sectionType: 'v2-nav2',
  },
  {
    selector:
      '.v2-navFrame[class*="__v2_banner_"] .v2-nav-li, .v2-nav-fixed[class*="__v2_banner_"] .v2-nav-li',
    event: 'click_item_detail_nav',
    context: 'pdp_detail_nav',
    source: 'vendor',
    sectionType: 'v2-banner',
  },
  {
    selector: '.v2-faq .faq-point',
    event: 'click_faq',
    context: 'pdp_faq',
    source: 'vendor',
    sectionType: 'v2-faq',
  },
  {
    selector: '[class^="v3-god"] .faq .faqPoint',
    event: 'click_faq',
    context: 'pdp_faq',
    source: 'vendor',
    sectionType: 'v3-faq',
  },
  {
    selector: '[data-lp4-side-nav-target]',
    event: 'click_item_detail_nav',
    context: 'pdp_detail_nav',
    source: 'vendor',
    sectionType: 'lp4-side-navigation',
  },
  {
    selector: '.lp4-faq [data-lp4-faq-trigger]',
    event: 'click_faq',
    context: 'pdp_faq',
    source: 'vendor',
    sectionType: 'lp4-faq',
  },
  {
    selector:
      '[data-migration-page="campaign"] .smb-community-content form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'campaign_product',
    source: 'vendor',
    sectionType: 'ny-tab-product',
  },
  {
    selector:
      '[data-migration-page="campaign"][class*="v2-percentFourProduct"] form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'campaign_product',
    source: 'vendor',
    sectionType: 'spring-percent-four-product-2',
  },
  {
    selector:
      '[data-migration-page="campaign"][class*="v2-productSideSwiper"] form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'campaign_product',
    source: 'vendor',
    sectionType: 'spring-product-side-swiper-2',
  },
  {
    selector:
      '[data-migration-page="campaign"][class*="v2-kv"] form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'campaign_product',
    source: 'vendor',
    sectionType: 'spring-v2-kv2',
  },
  {
    selector:
      '[data-migration-page="campaign"][class*="v2-fourProduct"] form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'campaign_product',
    source: 'vendor',
    sectionType: 'va-four-product',
  },
  {
    selector: '[data-3d-section="3d-materials"] form[is="product-form"] button[data-material-atc]',
    event: 'custom_add_to_cart',
    context: 'campaign_product',
    source: 'vendor',
    sectionType: '3d-materials',
    storeKeys: ['laserpecker-global'],
  },
  {
    selector:
      '[data-craft-fair-section="smb-calculator"] form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'smb_product',
    source: 'vendor',
    sectionType: 'smb-calculator',
  },
  {
    selector:
      '[data-craft-fair-section="smb-professional"] form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'smb_product',
    source: 'vendor',
    sectionType: 'smb-professional',
  },
  {
    selector: '[data-craft-fair-section="smb-rank"] form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'smb_product',
    source: 'vendor',
    sectionType: 'smb-rank',
  },
  {
    selector: '[data-smb-v2-component="channel"] form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'smb_product',
    source: 'vendor',
    sectionType: 'smb-v2-channel',
  },
  {
    selector: '[data-smb-v2-component="journey"] form[is="product-form"] button[type="submit"]',
    event: 'custom_add_to_cart',
    context: 'smb_product',
    source: 'vendor',
    sectionType: 'smb-v2-journey',
  },
  {
    selector: '.shopify-section--product-recommendations',
    event: 'you_may_also_like',
    context: 'pdp_recommendations',
    source: 'vendor',
  },
  {
    selector: 'section.lp5-compatible-products',
    event: 'you_may_also_like',
    context: 'pdp_recommendations',
    source: 'vendor',
    sectionType: 'product-recommendations',
  },
  {
    selector:
      '.shopify-section--product-recommendations .product-card .product-card__quick-buy > form[is="product-form"] button[type="submit"], .shopify-section--product-recommendations .product-card button[aria-controls^="quick-buy-"]',
    event: 'custom_add_to_cart',
    context: 'pdp_recommendations',
    source: 'vendor',
  },
  {
    selector:
      '.lp5-compatible-products .product-card .product-card__quick-buy > form[is="product-form"] button[type="submit"], .lp5-compatible-products .product-card button[aria-controls^="quick-buy-"]',
    event: 'custom_add_to_cart',
    context: 'pdp_recommendations',
    source: 'vendor',
  },
  {
    selector: '.shopify-section--main-product product-gallery page-dots button[type="button"]',
    event: 'slide_item_image',
    context: 'pdp_gallery',
    source: 'vendor',
  },
  {
    selector: 'cart-drawer a[href*="/cart/change"]',
    event: 'remove_from_cart',
    context: 'cart_drawer',
    source: 'vendor',
  },
  {
    selector: '.shopify-section--main-cart a[href*="/cart/change"]',
    event: 'remove_from_cart',
    context: 'cart_page',
    source: 'vendor',
  },
  {
    selector: 'cart-drawer a.button[href="/cart"]',
    event: 'click_view_cart',
    context: 'cart_drawer',
    source: 'vendor',
  },
  {
    selector:
      '.shopify-section-group-footer-group.shopify-section--newsletter form[action*="/contact"] button[type="submit"], .footer__newsletter-form button[type="submit"]',
    event: 'subscribe',
    context: 'footer',
    source: 'vendor',
  },
  {
    selector: '.footer',
    event: 'view_footer',
    context: 'footer',
    source: 'vendor',
  },
  {
    selector: '.footer .social-media a[href]',
    event: 'follow_us',
    context: 'footer_social',
    source: 'vendor',
  },
])

const observerStates = new WeakMap()
const headerCategorySelectEvents = Object.freeze({
  click_top_category: 'select_top_category',
  click_second_category: 'select_second_category',
})
const headerCategorySelectStoreKeys = new Set([
  'laserpecker-us',
  'laserpecker-uk',
  'laserpecker-eu',
  'laserpecker-ca',
  'laserpecker-de',
  'laserpeckerjp',
  'laserpecker-global',
])

function matchingElements(root, selector) {
  const elements = []
  if (root?.matches?.(selector)) elements.push(root)
  for (const element of root?.querySelectorAll?.(selector) ?? []) elements.push(element)
  return elements
}

export function resolveHeaderCategorySemantics(root) {
  return headerCategorySelectStoreKeys.has(resolveRuntimeStoreKey(root)) ? 'select' : 'click'
}

export function resolveRuntimeStoreKey(root) {
  const profile = root?.querySelector?.('#lp-global-integrations-profile')
  if (!profile?.textContent) return null

  try {
    return JSON.parse(profile.textContent).runtimeStoreKey ?? null
  } catch {
    return null
  }
}

function trackingEventForSemantics(hook, headerCategorySemantics) {
  if (headerCategorySemantics !== 'select') return hook.event
  return headerCategorySelectEvents[hook.event] ?? hook.event
}

export function annotateTrackingHooks(
  root,
  { headerCategorySemantics = 'click', runtimeStoreKey = null } = {},
) {
  const annotated = new Set()

  for (const hook of TRACKING_HOOKS) {
    if (hook.storeKeys && !hook.storeKeys.includes(runtimeStoreKey)) continue
    const trackingEvent = trackingEventForSemantics(hook, headerCategorySemantics)
    for (const element of matchingElements(root, hook.selector)) {
      if (element.hasAttribute('data-lp-track')) {
        const canRefreshContext =
          hook.refreshContext === true &&
          element.getAttribute('data-lp-track') === trackingEvent &&
          element.getAttribute('data-lp-track-source') === hook.source
        if (!canRefreshContext || element.getAttribute('data-lp-track-context') === hook.context) {
          continue
        }

        element.setAttribute('data-lp-track-context', hook.context)
        annotated.add(element)
        continue
      }
      element.setAttribute('data-lp-track', trackingEvent)
      element.setAttribute('data-lp-track-context', hook.context)
      element.setAttribute('data-lp-track-source', hook.source)
      if (hook.sectionType) element.setAttribute('data-lp-section-type', hook.sectionType)
      annotated.add(element)
    }
  }

  return annotated.size
}

// GA4 enhanced measurement remains the sole video-event owner. Migrated DE
// banner modals need the same YouTube API connection as Impact video-media.
export function createBannerYouTubeApiBridge(root) {
  const noop = { prepare() {}, prune() {}, stop() {} }
  try {
    const profile = JSON.parse(
      root?.querySelector?.('#lp-global-integrations-profile')?.textContent,
    )
    if (profile.runtimeStoreKey !== 'laserpecker-de') return noop
  } catch {
    return noop
  }
  const win = root.defaultView
  if (!win || !root.head) return noop
  const pending = new WeakSet()
  const players = new Map()
  let active = true
  let apiPromise
  const getApi = () => {
    if (win.YT?.Player) return Promise.resolve(win.YT)
    if (apiPromise) return apiPromise
    apiPromise = new Promise((resolve) => {
      let script = root.querySelector('script[src="https://www.youtube.com/iframe_api"]')
      const existingScript = Boolean(script)
      if (!script) {
        script = root.createElement('script')
        script.src = 'https://www.youtube.com/iframe_api'
      }
      const finish = (api) => {
        win.clearTimeout(timeout)
        script.removeEventListener('load', ready)
        script.removeEventListener('error', failed)
        resolve(api)
      }
      const ready = () => {
        if (win.YT?.Player) finish(win.YT)
        else win.YT?.ready?.(() => finish(win.YT?.Player ? win.YT : null))
      }
      const failed = () => finish(null)
      const timeout = win.setTimeout(failed, 15000)
      script.addEventListener('load', ready, { once: true })
      script.addEventListener('error', failed, { once: true })
      if (existingScript) ready()
      else root.head.append(script)
    })
    return apiPromise
  }
  return {
    prepare(node) {
      for (const iframe of matchingElements(
        node,
        'iframe.top-banner-video, .vPopupFrame iframe.ytv',
      )) {
        if (pending.has(iframe)) continue
        let url
        try {
          url = new URL(iframe.getAttribute('src'), root.location.href)
        } catch {
          continue
        }
        if (!['www.youtube.com', 'www.youtube-nocookie.com'].includes(url.hostname)) continue
        if (!url.pathname.startsWith('/embed/')) continue
        pending.add(iframe)
        url.searchParams.set('enablejsapi', '1')
        url.searchParams.set('origin', root.location.origin)
        if (iframe.src !== url.href) iframe.src = url.href
        getApi().then((api) => {
          if (!active || !api || !iframe.isConnected) return
          players.set(iframe, new api.Player(iframe, {}))
        })
      }
    },
    prune() {
      for (const [iframe, player] of players) {
        if (iframe.isConnected) continue
        player.destroy()
        players.delete(iframe)
      }
    },
    stop() {
      active = false
      this.prune()
      players.clear()
    },
  }
}

export function startTrackingHooks(
  root = document,
  {
    MutationObserver: Observer = globalThis.MutationObserver,
    headerCategorySemantics = resolveHeaderCategorySemantics(root),
    runtimeStoreKey = resolveRuntimeStoreKey(root),
  } = {},
) {
  const existing = observerStates.get(root)
  if (existing) return existing.stop

  annotateTrackingHooks(root, { headerCategorySemantics, runtimeStoreKey })
  if (typeof Observer !== 'function') return () => {}
  const youtubeBridge = createBannerYouTubeApiBridge(root)
  youtubeBridge.prepare(root)

  const observer = new Observer((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes ?? []) {
        if (node?.nodeType !== 1) continue
        annotateTrackingHooks(node, { headerCategorySemantics, runtimeStoreKey })
        youtubeBridge.prepare(node)
      }
    }
    youtubeBridge.prune()
  })
  const target = root?.documentElement ?? root
  observer.observe(target, { childList: true, subtree: true })

  const state = {
    stop() {
      if (observerStates.get(root) !== state) return
      observer.disconnect()
      youtubeBridge.stop()
      observerStates.delete(root)
    },
  }
  observerStates.set(root, state)
  return state.stop
}

if (typeof document !== 'undefined') {
  const start = () => startTrackingHooks(document)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true })
  } else {
    start()
  }
}
